import { Link } from '@tanstack/react-router'
import EventPayIcon from '@/assets/EventPay-Icon.svg'

export function NotFound() {
  return (
    <div className="min-h-screen relative overflow-hidden">
      {/* Sky background with clouds effect */}
      <div className="absolute inset-0 bg-gradient-to-b from-sky-300 via-sky-200 to-sky-100" />
      
      {/* Decorative circles/arcs */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute top-1/4 left-1/2 -translate-x-1/2 w-[1200px] h-[1200px] rounded-full border border-white/30" />
        <div className="absolute top-1/3 left-1/2 -translate-x-1/2 w-[900px] h-[900px] rounded-full border border-white/20" />
      </div>
      
      {/* Cloud-like shapes */}
      <div className="absolute bottom-0 left-0 right-0 h-64 bg-gradient-to-t from-white/80 to-transparent" />
      <div className="absolute bottom-20 left-10 w-64 h-32 bg-white/50 rounded-full blur-3xl" />
      <div className="absolute bottom-32 right-20 w-80 h-40 bg-white/40 rounded-full blur-3xl" />
      <div className="absolute bottom-10 left-1/3 w-72 h-36 bg-white/60 rounded-full blur-3xl" />
      
      {/* Content */}
      <div className="relative min-h-screen flex items-center justify-center px-4 py-12">
        <div 
          className="w-full max-w-md text-center"
          style={{
            animation: 'fadeInUp 0.6s ease-out forwards',
          }}
        >
          <div className="bg-gradient-to-b from-white/95 to-sky-50/90 backdrop-blur-xl rounded-3xl shadow-xl shadow-sky-200/50 border border-white/60 p-8">
            {/* Logo */}
            <div className="flex justify-center mb-6">
              <img 
                src={EventPayIcon} 
                alt="EventPay" 
                className="w-16 h-16 rounded-2xl shadow-lg shadow-blue-500/30"
              />
            </div>
            
            {/* 404 Text */}
            <h1 className="text-7xl font-bold text-neutral-900 mb-2">404</h1>
            <h2 className="text-xl font-semibold text-neutral-700 mb-4">Page Not Found</h2>
            <p className="text-neutral-500 text-sm mb-8">
              The page you're looking for doesn't exist or has been moved.
            </p>
            
            {/* Actions */}
            <div className="space-y-3">
              <Link
                to="/events"
                className="block w-full h-12 rounded-xl bg-neutral-900 hover:bg-neutral-800 text-white font-medium text-base shadow-lg shadow-neutral-900/20 transition-all hover:shadow-xl hover:shadow-neutral-900/30 flex items-center justify-center"
              >
                Go to Dashboard
              </Link>
              <button
                onClick={() => window.history.back()}
                className="block w-full text-sm text-neutral-500 hover:text-neutral-700 transition-colors py-2"
              >
                ← Go Back
              </button>
            </div>
          </div>
        </div>
      </div>
      
      {/* Keyframe animation */}
      <style>{`
        @keyframes fadeInUp {
          from {
            opacity: 0;
            transform: translateY(20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
      `}</style>
    </div>
  )
}
